<cc-container>
  <div class="back">
    <button
      mat-raised-button
      type="button"
      [routerLink]="['/blacklist/choose', this.action.toLowerCase()]"
      color="primary">
      <span translate>BACK</span>
    </button>
  </div>
  <cc-white-block>
    <cc-header-block>
      <div>
        <img
          src="../../../assets/img/add_individual_contacts.png"
          alt="add_individual_contacts">
        <span translate>BLACKLIST.{{this.action}}_CONTACTS.HEADER</span>
      </div>
      <div translate>BLACKLIST.MANUAL_IMPORT.DESCRIPTION_PART1</div>
      <div translate>BLACKLIST.MANUAL_IMPORT.{{this.action}}.DESCRIPTION_PART2</div>
    </cc-header-block>
    <textarea
      #textarea
      [rows]="textareaRows"
      [placeholder]="textareaPlaceholder"></textarea>
    <div class="actions">
      <button
        mat-raised-button
        type="button"
        *ngIf="textarea.value"
        routerLink="/blacklist"
        color="primary">
        <span translate>CANCEL</span>
      </button>
      <button
        mat-raised-button
        type="button"
        [disabled]="!textarea.value"
        (click)="actionNumbersToBlackList(textarea.value)"
        color="primary">
        <span translate>BLACKLIST.{{this.action}}</span>
      </button>
    </div>
  </cc-white-block>
</cc-container>
